import React, { useEffect, useRef, useState } from 'react';
import './emoji.style.scss';
import { __EmojiProps, __EmojiRef } from './emoji.interface';
import { TextDirection } from 'interface';
import HintText from '../hintText/hintText.index';
import QuestionImage from '../questionImage/questionImage.index';
import { __DropDownOption as DropDownOption } from '../dropdown/dropdown.interface';
import { extractTitle } from 'scripts/string';
export interface SLPEmojiRef extends __EmojiRef {}


const SLPEmoji: React.ForwardRefRenderFunction<__EmojiRef, __EmojiProps> = (props: __EmojiProps, ref) => {
    const [value, setValue] = useState<DropDownOption | null>(props.defaultValue ? props.defaultValue : null);
    const immediateValue = useRef<DropDownOption | null>(value);
    const [error, setError] = useState<string>();
    const labelRef = useRef<HTMLLabelElement>(null);

    React.useImperativeHandle(ref, () => ({
        getValue: () => immediateValue.current,
        getValidation: () => (props.required === true ? value !== null : true),
        setError: (text) => setError(text),
    }));

    const changeHandler = (e: DropDownOption) => {
        immediateValue.current = e;
        setValue(immediateValue.current);
        setError(undefined);
        if (props.onChange) props.onChange(e);
    };

    useEffect(() => {
        if (labelRef.current && props.label) labelRef.current.innerHTML = extractTitle(props.label, false);
    }, [props.label]);

    return (
        <div className={`ucheck-SLP-emoji ${props.dir === TextDirection.rtl ? 'rtl-text' : ''}`}>
            <div className="emoji-header">
                {props.required && <span className="required-star">*</span>}
                <span className="counter-span">{props.counter ? props.counter + '- ' : ''}</span>
                <label ref={labelRef} style={{ color: props.labelColor }} />
            </div>
            <QuestionImage src={props.image?.file} />
            <HintText value={props.hint} />
            <div className="emoji-container">
                {props.emojis.map((emoji) =>
                    emoji.archive ? null : (
                        <div
                            className={`${
                                emoji.value === value?.value ? 'selected' : ''
                            } d-flex flex-column align-items-center`}
                            onClick={() => changeHandler(emoji)}
                            key={emoji.payload}
                        >
                            <span>{String.fromCodePoint(Number(emoji.value ? emoji.value : emoji.payload))}</span>
                            {props.showTitles && <p>{emoji.title}</p>}
                        </div>
                    ),
                )}
            </div>
            {error && <p className="rate-error">{error}</p>}
        </div>
    );
};

export default React.forwardRef(SLPEmoji);
